import type { TabsProps } from "antd";
import { Layout, Row, Tabs, Typography, message } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import ArrowLeftIconComponent from "../../../components/ArrowLeftIconComponent";
import CreatorPaymentHistoryPaymentTabComponent from "../../../components/CreatorPaymentHisotryPaymentTabComponent";
import CreatorPaymentHistoryMonthlyReportTabComponent from "../../../components/CreatorPaymentHistoryMonthlyReportTabComponent";
import PaymentHistoryOverlayComponent from "../../../components/PaymentHistoryOverlayComponent/PaymentHistoryOverlayComponent";
import { IPayoutRequest } from "../../../helpers/types";
import { payoutRequestService } from "../../../services/payoutRequest.service";
import useInfiniteScroll from "react-infinite-scroll-hook";
import useFetchUserSettings from "../../../hooks/userHooks/useFetchUserSettings";
import { AppDispatch } from "../../../redux/store";
import { updateUserSettingsStatus } from "../../../redux/users/usersSlice";
import "./index.less";

const CreatorPaymentHistoryPage = () => {
  const limit = 20;
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { currentUserSettings } = useFetchUserSettings();
  const [payoutRequests, setPayoutRequests] = useState<IPayoutRequest[]>([]);
  const [offset, setOffSet] = useState<any>(0);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    loadMoreData();
  }, []);

  useEffect(() => {
    if (currentUserSettings && payoutRequests.length > 0) {
      const hasSeenModal = currentUserSettings?.visibilityStatus.hasSeenPaymentHistoryModal;
      setShowOverlay(hasSeenModal === false);
    }
  }, [currentUserSettings?.visibilityStatus.hasSeenPaymentHistoryModal, payoutRequests.length]);

  const loadMoreData = async () => {
    if (loading || !hasMore) return;

    setLoading(true);
    try {
      const response = await payoutRequestService.getPayoutHistory({ limit, offset });
      if (response.status === 0) {
        let data = [...payoutRequests, ...response.data.payment];
        setLoading(false);
        setPayoutRequests(data);
        setOffSet(data.length);
        if (data.length >= response.data.totalPayments) {
          setHasMore(false);
          setLoading(false);
        }
      }
    } catch (error) {
      message.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage: hasMore,
    onLoadMore: loadMoreData,
  });

  const handleCloseOverlay = () => {
    setShowOverlay(false);
    if (!currentUserSettings?.visibilityStatus.hasSeenPaymentHistoryModal) {
      dispatch(updateUserSettingsStatus("hasSeenPaymentHistoryModal"));
    }
  };

  return (
    <Layout>
      <Layout.Content className="content creatorPaymentHistoryContentWrapper gradient-background-black-blue">
        <Row className="relative justify-content-center header-title-container">
          <ArrowLeftIconComponent left={0} top={0} />
          <Typography.Text className="header-title-black-20">{t("payments-history")}</Typography.Text>
        </Row>
        <CreatorPaymentHistoryPaymentTabComponent
          list={payoutRequests}
          sentryRef={sentryRef}
          hasMore={hasMore}
          loading={loading}
          showGif={showOverlay}
        />
        {showOverlay && <PaymentHistoryOverlayComponent onClose={handleCloseOverlay} />}
      </Layout.Content>
    </Layout>
  );
};

export default CreatorPaymentHistoryPage;
